import React, { useState, useContext, useEffect } from "react";
import {
  ManageMapperLayout,
  FieldButtonGroup,
  NotificationPopUp,
  LoaderWrapper,
} from "../../../components";
import CategorySelectionContainer from "./CategorySelectionContainer";
import { Form } from "react-bootstrap";
import { Formik, Field } from "formik";
import SelectFields from "./SelectFields";
import AggregateKeys from "./AggregateKeys";
import { isEmpty, get } from "lodash";
import {
  getPathWithParam,
  MANAGE_MAPPER_ROUTES,
  FLOW_TYPES,
  ROUTES,
} from "../../../utils";
import { useRouterParams } from "../../../abstracts";
import {
  manageMapperStore,
  setManageMapperToastInfo,
  setMapperPageLevelData,
  MANAGE_MAPPER_POST_API_ERROR,
  setFileUploadData,
} from "../../../contexts";
import { onAggregateSave, onPassthroughAggregateSave } from "../../../services";
import NotificationPopUpMapper from "../../../components/NotificationPopupMapper/NotificationPopUpMapper";

const initialValues = {};

const AggregateContainer = (props) => {
  const [dataLoading, setDataLoading] = useState(false);
  const [aggregateData, setAggregateData] = useState([]);
  const { state, dispatch } = useContext(manageMapperStore);
  const { flow, profileId, mapType } = useRouterParams();
  const isEdit = flow === FLOW_TYPES.EDIT;
  const data = get(state, "api.data", []);
  const AggregateData =
    isEdit &&
    !isEmpty(get(state, "EditedAggregateData", [])) &&
    get(state, "EditedAggregateData", []);

  const AggregateDataCreate =
    !isEdit &&
    !isEmpty(get(state, "EditedAggregateDataCreate", [])) &&
    get(state, "EditedAggregateDataCreate", []);

  const aggregateValues =
    !isEmpty(get(data, "aggregationModelJson", {})) &&
    JSON.parse(get(data, "aggregationModelJson", {}));

  const DetermineAggregateInitial = () => {
    if (isEdit) {
      if (isEmpty(get(state, "EditedAggregateData", []))) {
        const InitialData = {
          isAggregationModel: get(data, "isAggregationModel", false),
          aggregationStrategy: get(aggregateValues, "aggregationStrategy", "1"),
          aggregationEntites: get(aggregateValues, "aggregationEntites", []),
          aggregationOperationEntities: get(
            aggregateValues,
            "aggregationOperationEntities",
            []
          ),
        };
        return InitialData;
      }
      {
        const InitialData = {
          isAggregationModel: get(AggregateData, "isAggregationModel", false),
          aggregationStrategy: get(
            AggregateData,
            "aggregationModelJson.aggregationStrategy",
            "1"
          ),
          aggregationEntites: get(
            AggregateData,
            "aggregationModelJson.aggregationEntites",
            []
          ),
          aggregationOperationEntities: get(
            AggregateData,
            "aggregationModelJson.aggregationOperationEntities",
            []
          ),
        };
        return InitialData;
      }
    } else {
      if (isEmpty(get(state, "EditedAggregateDataCreate", []))) {
        const InitialData = {
          isAggregationModel: get(data, "isAggregationModel", false),
          aggregationStrategy: get(aggregateValues, "aggregationStrategy", "1"),
          aggregationEntites: get(aggregateValues, "aggregationEntites", []),
          aggregationOperationEntities: get(
            aggregateValues,
            "aggregationOperationEntities",
            []
          ),
        };
        return InitialData;
      }
      {
        const InitialData = {
          isAggregationModel: get(
            AggregateDataCreate,
            "isAggregationModel",
            false
          ),
          aggregationStrategy: get(
            AggregateDataCreate,
            "aggregationModelJson.aggregationStrategy",
            "1"
          ),
          aggregationEntites: get(
            AggregateDataCreate,
            "aggregationModelJson.aggregationEntites",
            []
          ),
          aggregationOperationEntities: get(
            AggregateDataCreate,
            "aggregationModelJson.aggregationOperationEntities",
            []
          ),
        };
        return InitialData;
      }
    }
  };

  let AggregateInitialLoadingData = DetermineAggregateInitial();

  // Getting the data from DB using the API
  const [characters, setCharacters] = useState([]);

  //const fieldHeadersJson = get(state, "api.data.headerMapJson");
  const headersJson = get(data, "headerMapJson", []);
  const fileuploadData = get(state, "api.fileuploadData", []);
  const fileUploadRow = JSON.stringify(get(fileuploadData, "row"));
  const fileUploadFields = fileUploadRow
    ? fileUploadRow
    : get(fileuploadData, "mappingConfiguration.headerMapJson", "");
  const fieldHeadersJson = !isEmpty(headersJson)
    ? headersJson
    : fileUploadFields;

  useEffect(() => {
    setCharacters(
      !isEmpty(fieldHeadersJson) &&
        JSON.parse(fieldHeadersJson)?.map((item) => {
          return {
            ...item,
            path: item.fieldName,
          };
        })
    );
  }, [fieldHeadersJson]);

  const yesNoOptions = [
    {
      label: "Yes",
      value: true,
    },
    {
      label: "No",
      value: false,
    },
  ];
  const [selectFields, setselectFields] = useState(false);
  const DeleteToastMessage = "Please add fields to aggregate ";
  const DeleteToastMessageHead = "";
  const handleCancelClick = () => {
    setShow(false);
  };
  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      link: ROUTES.MAPPER_HOME,
    },
    {
      label: "Next",
      variant: "primary",
      type: "submit",
    },
  ];
  const [isToast, setToast] = useState(false);
  const [show, setShow] = useState(false);
  const onSubmit = (values) => {
    const aggregateTrue = get(values, "isAggregationModel");
    const aggregateInfo = get(values, "aggregationEntites", []);
    if (aggregateTrue && isEmpty(aggregateInfo)) {
      setShow(true);
    } else {
      setShow(false);
    }
    const { history } = props;
    const aggregrateModel = {
      aggregationEntites: get(values, "aggregationEntites", []),
      // aggregationOperationEntities: get(
      //   values,
      //   "aggregationOperationEntities",
      //   []
      // ),
      aggregationOperationEntities: aggregateData,

      aggregationStrategy: get(values, "aggregationStrategy"),
    };
    let aggregateModelValue = null;
    if (get(values, "isAggregationModel", false)) {
      aggregateModelValue = JSON.stringify(aggregrateModel);
    }
    if (aggregateModelValue == null) {
      aggregrateModel.aggregationEntites = [];
      aggregrateModel.aggregationOperationEntities = [];
      aggregrateModel.aggregationStrategy = 1;
      aggregateModelValue = JSON.stringify(aggregrateModel);
    }

    const AggregateUpdateData = {
      isAggregationModel: get(values, "isAggregationModel"),
      aggregationModelJson: aggregrateModel,
    };
    if ((aggregateTrue && !isEmpty(aggregateInfo)) || !aggregateTrue) {
      setDataLoading(true);
      mapType == 3
        ? onPassthroughAggregateSave({
            profileId: profileId,
            isAggregationModel: get(values, "isAggregationModel"),
            aggregationModelJson: aggregateModelValue,
          })
            .then((res) => {
              if (!isEmpty(res)) {
                const outputTemplateMaps = JSON.parse(res["outputProfile"])[
                  "OutputTemplateMaps"
                ];
                res = { ...res, outputTemplateMaps };
                if (isEdit) {
                  history.push(MANAGE_MAPPER_ROUTES.OVERVIEW);
                  dispatch(
                    setMapperPageLevelData({
                      formName: "EditedAggregateData",
                      fieldData: AggregateUpdateData,
                      format: data.format
                        ? data.format
                        : fileuploadData.mappingConfiguration.format,
                    })
                  );
                  dispatch(
                    setFileUploadData({
                      mappingConfiguration: res,
                    })
                  );
                  dispatch(
                    setManageMapperToastInfo({
                      showToast: true,
                      toastMessage: "Data saved successfully",
                    })
                  );
                } else {
                  history.push(
                    getPathWithParam({
                      path: MANAGE_MAPPER_ROUTES.REVIEW_AND_CONFIRM,
                      pathParam: [mapType, profileId],
                    })
                  );
                  dispatch(
                    setMapperPageLevelData({
                      formName: "EditedAggregateDataCreate",
                      fieldData: AggregateUpdateData,
                      format: data.format
                        ? data.format
                        : fileuploadData.mappingConfiguration.format,
                    })
                  );
                  dispatch(
                    setManageMapperToastInfo({
                      showToast: true,
                      toastMessage: "Data saved successfully",
                    })
                  );
                }

                // history.push(`${MANAGE_MAPPER_ROUTES.TARGET}/${profileId}`);
              } else {
                dispatch({
                  type: MANAGE_MAPPER_POST_API_ERROR,
                  payload: "Something went wrong! please try again.",
                });
              }
              setDataLoading(false);
            })
            .catch(
              (err) => {
                setDataLoading(false);
              }
              // dispatch({
              //   type: MANAGE_MAPPER_POST_API_ERROR,
              //   payload: "Something went wrong! please try again.",
              // })
            )
        : onAggregateSave({
            ...data,
            isAggregationModel: get(values, "isAggregationModel"),
            aggregationModelJson: aggregateModelValue,
          })
            .then((res) => {
              if (!isEmpty(res)) {
                if (isEdit) {
                  history.push(
                    getPathWithParam({
                      path: MANAGE_MAPPER_ROUTES.RULESET,
                      pathParam: [FLOW_TYPES.EDIT, mapType, profileId],
                    })
                  );
                  dispatch(
                    setMapperPageLevelData({
                      formName: "EditedAggregateData",
                      fieldData: AggregateUpdateData,
                      format: data.format
                        ? data.format
                        : fileuploadData.mappingConfiguration.format,
                    })
                  );
                  dispatch(
                    setFileUploadData({
                      mappingConfiguration: res,
                    })
                  );
                  dispatch(
                    setManageMapperToastInfo({
                      showToast: true,
                      toastMessage: "Data saved successfully",
                    })
                  );
                } else {
                  history.push(
                    getPathWithParam({
                      path: MANAGE_MAPPER_ROUTES.RULESET,
                      pathParam: [mapType, profileId],
                    })
                  );
                  dispatch(
                    setMapperPageLevelData({
                      formName: "EditedAggregateDataCreate",
                      fieldData: AggregateUpdateData,
                      format: data.format
                        ? data.format
                        : fileuploadData.mappingConfiguration.format,
                    })
                  );
                  dispatch(
                    setManageMapperToastInfo({
                      showToast: true,
                      toastMessage: "Data saved successfully",
                    })
                  );
                }
                setDataLoading(false);
                // history.push(`${MANAGE_MAPPER_ROUTES.TARGET}/${profileId}`);
              } else {
                dispatch({
                  type: MANAGE_MAPPER_POST_API_ERROR,
                  payload: "Something went wrong! please try again.",
                });
              }
            })
            .catch(
              (err) => err,
              setDataLoading(false)
              // dispatch({
              //   type: MANAGE_MAPPER_POST_API_ERROR,
              //   payload: "Something went wrong! please try again.",
              // })
            );
    }
  };

  const onClickOk = (isTrue) => {
    if (!isTrue) {
      setShow(false);
    }
  };

  return (
    <Formik
      initialValues={{
        ...initialValues,
        isAggregationModel: AggregateInitialLoadingData.isAggregationModel,
        aggregationStrategy: AggregateInitialLoadingData.aggregationStrategy,
        aggregationEntites: AggregateInitialLoadingData.aggregationEntites,
        aggregationOperationEntities:
          AggregateInitialLoadingData.aggregationOperationEntities,
      }}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={onSubmit}
    >
      {(formProps) => {
        const {
          handleChange,
          setFieldValue,
          handleSubmit,
          setValues,
          setTouched,
          values,
          setSubmitting,
          ...rest
        } = formProps;
        return (
          <Form autoComplete="off" className="h-100" onSubmit={handleSubmit}>
            <LoaderWrapper isLoading={dataLoading}>
              <ManageMapperLayout buttons={buttons}>
                <div
                  style={{
                    display: "block",
                    fontSize: "18px",
                    fontWeight: "500",
                    alignItems: "center",
                    paddingBottom: "0",
                  }}
                >
                  <div
                    style={{
                      paddingBottom: "0.5rem",
                      color: "#494F5A",
                      fontSize: "18px",
                      fontWeight: "550",
                    }}
                  >
                    Apply aggregate
                  </div>
                  <div style={{ display: "flex" }}>
                    <Field
                      isRequired
                      name="isAggregationModel"
                      size="md"
                      className="bg-transparent p-0"
                      options={yesNoOptions}
                      selectedValue={values["isAggregationModel"]}
                      onChange={(value) => {
                        setFieldValue("isAggregationModel", value);
                        setFieldValue("aggregationEntites", []);
                        setFieldValue("aggregationStrategy", null);
                      }}
                      component={FieldButtonGroup}
                    />
                  </div>
                </div>

                {values["isAggregationModel"] ? (
                  <div className="load-container">
                    <AggregateKeys
                      setselectFields={setselectFields}
                      values={values}
                      setValues={setValues}
                    />
                    <CategorySelectionContainer
                      fields={characters}
                      values={values}
                      setValues={setValues}
                      setFieldValue={setFieldValue}
                      aggregateData={aggregateData}
                      setAggregateData={setAggregateData}
                    />
                    <div
                      id="fade-in-aggcontainer"
                      className={
                        "border rounded px-3 bg-white " +
                        (() => (selectFields ? "show" : "box"))()
                      }
                    >
                      <SelectFields
                        setselectFields={setselectFields}
                        selectFields={selectFields}
                        fields={characters}
                        values={values}
                        setValues={setValues}
                        setFieldValue={setFieldValue}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="FilterUnavailable">Aggregate not applied</div>
                )}
              </ManageMapperLayout>

              <NotificationPopUpMapper
                DeleteToastMessageHead={DeleteToastMessageHead}
                DeleteToastMessage={DeleteToastMessage}
                showModal={show}
                handleCancelClick={handleCancelClick}
              />
            </LoaderWrapper>
          </Form>
        );
      }}
    </Formik>
  );
};

export default AggregateContainer;
